// Route-level error element for react-router data routers.
//
// createBrowserRouter catches render errors per route and — without an errorElement —
// shows its own developer default page in place of the whole tree, bypassing the
// app-level ErrorBoundary. Attaching this to a child route keeps AppLayout mounted and
// shows the failure inline in the Outlet instead. Task 330.

import React from 'react';
import { Button, Result, Typography } from 'antd';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`;
  if (error instanceof Error) return error.message;
  return 'An unexpected error occurred.';
}

export default function RouteErrorElement(): React.ReactElement {
  const error = useRouteError();
  const navigate = useNavigate();
  console.error('[RouteErrorElement]', error);

  return (
    <Result
      status="error"
      title="This page failed to render"
      subTitle={<Typography.Text type="secondary">{describe(error)}</Typography.Text>}
      extra={[
        <Button key="reload" type="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>,
        <Button key="back" onClick={() => navigate(-1)}>
          Go back
        </Button>,
      ]}
    />
  );
}
